if (!customElements.get('quick-view-modal')) {
  customElements.define(
    'quick-view-modal',
    class QuickViewModal extends HTMLElement {
      connectedCallback() {
        if (!this.moved) {
          this.moved = true;
          const trigger = this.previousElementSibling;
          if (trigger) trigger.quickViewModal = this;
          document.body.appendChild(this);
        }

        if (this.bound) return;
        this.bound = true;

        const dataEl = this.querySelector('[data-quick-view-variants]');
        this.variants = dataEl ? JSON.parse(dataEl.textContent) : [];
        this.buyPrefix = this.dataset.buyPrefix || 'Add to cart';

        this.querySelectorAll('[data-quick-view-close]').forEach((el) => {
          el.addEventListener('click', () => this.close());
        });

        this.addEventListener('keyup', (event) => {
          if (event.code === 'Escape') this.close();
        });

        this.optionGroups = Array.from(this.querySelectorAll('[data-quick-view-option]'));
        this.optionGroups.forEach((group) => {
          group.querySelectorAll('.quick-view-modal__pill').forEach((pill) => {
            pill.addEventListener('click', () => this.selectPill(group, pill));
          });
        });

        this.variantInput = this.querySelector('[data-quick-view-variant-input]');
        this.buyButton = this.querySelector('.quick-view-modal__buy');
        this.buyLabel = this.querySelector('[data-quick-view-buy-label]');
      }

      selectPill(group, pill) {
        group.querySelectorAll('.quick-view-modal__pill').forEach((p) => p.classList.remove('is-selected'));
        pill.classList.add('is-selected');

        this.updateVariant();
      }

      updateVariant() {
        const selected = this.optionGroups.map((group) => {
          const active = group.querySelector('.quick-view-modal__pill.is-selected');
          return active ? active.dataset.value : null;
        });

        const match = this.variants.find((variant) =>
          variant.options.every((value, index) => value === selected[index])
        );
        if (!match || !this.variantInput) return;

        this.variantInput.value = match.id;

        if (this.buyLabel) {
          this.buyLabel.textContent = `${this.buyPrefix} · ${match.priceFormatted}`;
        }

        if (this.buyButton) {
          this.buyButton.disabled = !match.available;
        }
      }

      open(trigger) {
        this.openedBy = trigger;
        document.body.classList.add('overflow-hidden');
        this.setAttribute('open', '');
        this.positionNear(trigger);
        const closeButton = this.querySelector('.quick-view-modal__close');
        if (closeButton) closeButton.focus();
      }

      positionNear(trigger) {
        const card = this.querySelector('.quick-view-modal__card');
        if (!card || !trigger) return;

        const margin = 16;
        const gap = 12;
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
        const triggerRect = trigger.getBoundingClientRect();
        const cardRect = card.getBoundingClientRect();
        const cardWidth = cardRect.width;
        const cardHeight = cardRect.height;

        let left = triggerRect.left + triggerRect.width / 2 - cardWidth / 2;
        left = Math.min(Math.max(left, margin), Math.max(margin, viewportWidth - cardWidth - margin));

        const spaceAbove = triggerRect.top - margin;
        const spaceBelow = viewportHeight - triggerRect.bottom - margin;
        let top;
        if (cardHeight <= spaceAbove) {
          top = triggerRect.top - cardHeight - gap;
        } else if (cardHeight <= spaceBelow) {
          top = triggerRect.bottom + gap;
        } else {
          top = Math.min(
            Math.max(triggerRect.top - cardHeight / 2, margin),
            Math.max(margin, viewportHeight - cardHeight - margin)
          );
        }

        card.style.left = `${left}px`;
        card.style.top = `${top}px`;
        card.style.transform = 'none';
      }

      close() {
        document.body.classList.remove('overflow-hidden');
        this.removeAttribute('open');
        const card = this.querySelector('.quick-view-modal__card');
        if (card) {
          card.style.left = '';
          card.style.top = '';
          card.style.transform = '';
        }
        if (this.openedBy) this.openedBy.focus();
      }
    }
  );
}

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-quick-view-trigger]');
  if (!trigger) return;
  const modal = trigger.quickViewModal;
  if (modal) modal.open(trigger);
});
